<template>
  <div class="forbidden-page">
    <div class="forbidden-card">
      <div class="status-icon">!</div>
      <h1>暂无访问权限</h1>
      <p class="user-info">{{ userText }}</p>
      <p class="message">暂无餐厅后台管理权限，请联系管理员</p>
      <p class="hint">管理员配置角色后，请退出并重新登录。</p>
      <van-button block round type="primary" :loading="loading" @click="handleLogout">
        退出登录
      </van-button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { useAuthStore } from '@/store/auth';

  const authStore = useAuthStore();
  const router = useRouter();
  const loading = ref(false);

  const userText = computed(() => {
    const user = authStore.user;
    if (!user) return '';
    return user.displayName === user.username
      ? user.username
      : `${user.displayName}（${user.username}）`;
  });

  const handleLogout = async (): Promise<void> => {
    loading.value = true;
    await authStore.logout();
    await router.replace('/login');
  };
</script>

<style scoped>
  .forbidden-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: #f5f5f5;
  }

  .forbidden-card {
    width: 100%;
    max-width: 420px;
    padding: 32px 24px;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 10px 30px rgba(24, 39, 75, 0.08);
  }

  .status-icon {
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 18px;
    border-radius: 50%;
    background: #fff7ed;
    color: #ea580c;
    font-size: 32px;
    font-weight: 700;
  }

  h1 {
    margin: 0 0 14px;
    color: #1e293b;
    font-size: 24px;
  }

  .user-info {
    margin: 0 0 12px;
    color: #475569;
    font-size: 15px;
  }

  .message {
    margin: 0;
    color: #334155;
    font-size: 16px;
    line-height: 1.6;
  }

  .hint {
    margin: 8px 0 24px;
    color: #64748b;
    font-size: 13px;
    line-height: 1.5;
  }
</style>
